module.exports = __webpack_public_path__ + "img/presales.5c7789a3.svg";